import { NavLink } from "react-router-dom";
import { IonRow } from "@ionic/react";
import { PageTitle } from "./PageTitle";
import { DarkTooltip } from "./DarkTooltip";

export const IconBar = (props) => {
  const { iconsMenu } = props;
  return (
    <div className="icon-bar">
      <PageTitle pageTitle={"FOLLOW ME"} />
      &nbsp;
      <IonRow className="icon-bar-row">
        {iconsMenu &&
          iconsMenu.map((item, index) => (
            <DarkTooltip key={index} title={item?.title}>
              <NavLink
                key={index}
                to={item?.link}
                className="nav-item"
                target="_blank"
                rel="noopener"
                aria-label="Follow me"
              >
                <item.Icon className="icon tooltip" />
              </NavLink>
            </DarkTooltip>
          ))}
      </IonRow>
    </div>
  );
};
